import { MobileDivider } from "@/components/atoms/Divider/MobileDivider/MobileDivider.style";

export const PMTitle = () => (
  <>
    그 고민의 돌파구가 <MobileDivider /> 되어드리겠습니다.
  </>
);

export const PMDesc = () => (
  <>
    SW캠프는 회사를 그만 두지 않고도 PM이라는 커리어 여정에 도전할 수 있도록
    고안된 3개월 과정의 파트타임 부트캠프입니다.
    <br />
    <br />
    먼저 문제를 정의하고 그 문제를 풀어보는 과정에서 현업의 훌륭한 시니어
    멘토들의 코칭을 받으실 수 있습니다. 단순히 더 좋은 PM이 되는 것을 넘어서
    커리어를 거듭할수록 계속해서 성장할 수 있는 PM이 되도록 도와드리겠습니다.
  </>
);

export const MktTitle = () => (
  <>
    이론에 그치지 않고,
    <MobileDivider />
    직접 경험해봐야 합니다.
  </>
);

export const MktDesc = () => (
  <>
    마케팅은 Market + ing, 즉 시장을 만드는 것이며, <br />
    마케터는 Market +er, 즉 시장을 만드는 사람입니다. <br />
    마케팅의 한 판을 보고, 시장을 만들어 나가세요. <br />
    <br />
    SW캠프 마케터 코스는 단기간 내에 실전 경험과 IT 지식을 두루 갖추고 차별화된
    마케터로 성장할 수 있는 과정입니다.
    <br />
    <br />
    나만의 뾰족한 무기를 갖되 마케팅 전체를 아우르는 지혜를 갖춘, T자형
    “마케터”로 거듭나세요.
  </>
);
